import React, { useEffect, useRef } from 'react';
import { FORM_NAME, STEP, STEPS, STREAM, STREAM_ERROR } from '../fields';
import { change, getFormValues, Field } from 'redux-form';
import { VideoListSelect, AudioListSelect } from '../devices';
import { Button } from 'components/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faCamera } from '@fortawesome/pro-regular-svg-icons';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { WebcamMirror } from '../webcam-mirror';
import { TextBox } from 'components/forms';
import { StreamErrorHint } from '../stream-error-hint';

export const ConfigurationTitle = () => {
  const { t } = useTranslation();
  return <>{t('configuration_title')}</>;
};

export const ConfigurationBody = () => {
  const { t } = useTranslation();
  const { [STREAM_ERROR]: streamError } = useSelector(getFormValues(FORM_NAME));

  return (
    <>
      {streamError ? (
        <StreamErrorHint />
      ) : (
        <Field
          name="agreedToRecord"
          component={TextBox}
          props={{
            text: t('recording_gdpr_text'),
            required: true,
          }}
        />
      )}
      <WebcamMirror />
    </>
  );
};

export const ConfigurationFooter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { [STREAM]: stream, audioDeviceIds, videoDeviceIds, agreedToRecord } = useSelector(getFormValues(FORM_NAME));
  const streamRef = useRef();
  streamRef.current = stream;

  const audioDeviceId = audioDeviceIds?.[0];
  const videoDeviceId = videoDeviceIds?.[0];

  useEffect(() => {
    if (audioDeviceId !== undefined && videoDeviceId !== undefined) {
      let isDead = false;

      if (streamRef.current) {
        window.VideoCaptureAPI.stopMediaTracks(streamRef.current);
        streamRef.current = null;
      }

      const getStream = async () => {
        const constraints = { videoDeviceId, audioDeviceId };
        const videoStream = await window.VideoCaptureAPI.getWebCamStream(constraints)?.catch((e) => {
          if (!isDead) {
            dispatch(
              change(FORM_NAME, STREAM_ERROR, {
                kind: e.name,
              })
            );
          }
        });

        if (!isDead && videoStream) {
          dispatch(change(FORM_NAME, STREAM, videoStream));
        }
      };

      getStream();

      return () => {
        isDead = true;
      };
    }
  }, [dispatch, audioDeviceId, videoDeviceId]);

  const onStartRecording = () => {
    dispatch(change(FORM_NAME, STEP, STEPS.RECORDING));
  };
  return (
    <div className="d-flex justify-content-between">
      <div className="d-flex justify-content-between align-items-center ct-device-list">
        <FontAwesomeIcon className="mr-2" icon={faCamera} />
        <VideoListSelect />
      </div>
      <div className="d-flex justify-content-between align-items-center ct-device-list">
        <FontAwesomeIcon className="mr-2" icon={faMicrophone} />
        <AudioListSelect />
      </div>

      <Button onClick={onStartRecording} disabled={!stream || !agreedToRecord}>
        {t('start_recording')}
      </Button>
    </div>
  );
};
